import { useNavigate } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import authService from "@/services/authService";
import { ChevronDown, FolderOpen, LayoutDashboard, LogOut, Mail, Shield } from "lucide-react";
import { toast } from "sonner";

export default function UserMenu({ user, displayName, className = "", onLogout }) {
  const navigate = useNavigate();
  const resolvedName = displayName || user?.name || user?.email?.split("@")[0] || "User";
  const initial = resolvedName.charAt(0).toUpperCase();
  const isAdmin = user?.role?.toLowerCase() === "admin";

  const handleLogout = async () => {
    try {
      if (onLogout) {
        await onLogout();
        return;
      }

      await authService.logout();
      navigate("/login");
      toast.success("Logged out successfully");
    } catch (error) {
      authService.clearTokens();
      navigate("/login");
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className={`hidden items-center gap-3 rounded-full px-2 py-1.5 text-left transition hover:bg-[#fff7e9] focus:outline-none focus:ring-2 focus:ring-[#c98905]/45 dark:hover:bg-[#1b1710] md:flex ${className}`}
          data-testid="user-menu-trigger"
        >
          <span className="grid h-11 w-11 place-items-center rounded-full bg-gradient-to-br from-[#f5cf75] to-[#9b6700] font-bold text-white">
            {initial}
          </span>
          <span className="max-w-32 truncate text-sm font-semibold text-slate-950 dark:text-[#f8efe0]">
            {resolvedName}
          </span>
          <ChevronDown className="h-4 w-4 text-[#c98905]" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-56 border-[#eadfcd] bg-white p-2 text-slate-900 shadow-xl dark:border-[#594719] dark:bg-[#11100d] dark:text-[#f8efe0]"
      >
        <DropdownMenuItem onClick={() => navigate("/dashboard")} className="cursor-pointer rounded-lg">
          <LayoutDashboard className="h-4 w-4 text-[#c98905]" />
          Dashboard
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate("/work")} className="cursor-pointer rounded-lg">
          <FolderOpen className="h-4 w-4 text-[#c98905]" />
          Work
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate("/inbox")} className="cursor-pointer rounded-lg">
          <Mail className="h-4 w-4 text-[#c98905]" />
          Inbox
        </DropdownMenuItem>
        {isAdmin ? (
          <DropdownMenuItem onClick={() => navigate("/admin")} className="cursor-pointer rounded-lg">
            <Shield className="h-4 w-4 text-[#c98905]" />
            Admin
          </DropdownMenuItem>
        ) : null}
        <DropdownMenuSeparator className="bg-[#eadfcd] dark:bg-[#3a2d13]" />
        <DropdownMenuItem onClick={handleLogout} className="cursor-pointer rounded-lg text-red-600 focus:text-red-700">
          <LogOut className="h-4 w-4" />
          Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}